import axios from "axios";
import { userBidsUrl } from "../utils";

export const fetchUserBids = (userId: string) => {
  return axios.get(userBidsUrl(userId));
};
